export function extractPageItems<T>(data: Record<string, unknown>): T[] {
	if (Array.isArray(data.items)) return data.items as T[];
	return ((data.events ??
		data.messages ??
		data.pushes ??
		data.balances ??
		data.ussds ??
		data.actions ??
		data.deviceLogs ??
		data.apps ??
		data.photos) ?? []) as T[];
}
